import { useState } from "react";
import { Heart } from "lucide-react";

const LIKE_COLOR = 'oklch(58.6% 0.253 17.585)';

const LikeButton = ({ liked = false, likeCount = 0, loading = false, onLike }) => {
  const [hovered, setHovered] = useState(false);
  const active = liked || hovered;

  return (
    <button
      onClick={onLike}
      disabled={loading}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      className={`flex items-center gap-1.5 p-2 rounded-full transition-all duration-200
        hover:scale-110 active:scale-95
        ${loading ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}
      `}
    >
      <Heart
        className="w-6 h-6 transition-all duration-200"
        style={{
          color: active ? LIKE_COLOR : 'rgb(243,244,246)',
          fill: liked ? LIKE_COLOR : 'transparent',
          filter: liked ? `drop-shadow(0 0 6px ${LIKE_COLOR})` : 'none',
        }}
      />
      {likeCount > 0 && (
        <span
          className="text-sm font-medium transition-colors duration-200"
          style={{ color: active ? LIKE_COLOR : 'rgb(209,213,219)' }}
        >
          {likeCount}
        </span>
      )}
    </button>
  );
};

export default LikeButton;
